// extracted by mini-css-extract-plugin
export default {"mainContainer":"GroupNameEditor_mainContainer__L0xuV","autocomplete":"GroupNameEditor_autocomplete__iN-kt"};